import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from './store/store';
import './index.css';
import App from './App';
import { AlertProvider } from './components/AlertBanner';
import reportWebVitals from './reportWebVitals';
import { initGA, initAmplitude, initMetaPixel, isAdminSession } from './utils/analytics';

// Skip all analytics/tracking SDKs entirely for an admin session (e.g. an
// admin returning to /admin with a persisted login) — admin activity in the
// dashboard (previewing a draft, reviewing a submission, etc.) is never a
// real user/marketing signal and shouldn't be sent to GA4, Amplitude, or
// Meta. This only catches sessions that are already admin at page load;
// trackMetaPixel has its own runtime check too, as a second guard.
if (!isAdminSession()) {
  // Initialize Google Analytics
  const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;
  if (GA_MEASUREMENT_ID) {
    console.log('GA_MEASUREMENT_ID is calling')
    initGA(GA_MEASUREMENT_ID);
    console.log('GA_MEASUREMENT_ID is called')

  }

  // Initialize Amplitude
  const AMPLITUDE_API_KEY = process.env.REACT_APP_AMPLITUDE_API_KEY;
  if (AMPLITUDE_API_KEY) {
    initAmplitude(AMPLITUDE_API_KEY);
  }

  // Initialize Meta Pixel
  const META_PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID;
  if (META_PIXEL_ID) {
    initMetaPixel(META_PIXEL_ID);
  }
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID || ''}>
      <Provider store={store}>
        <PersistGate loading={<div>Loading...</div>} persistor={persistor}>
          <BrowserRouter>
            <AlertProvider>
              <App />
            </AlertProvider>
          </BrowserRouter>
        </PersistGate>
      </Provider>
    </GoogleOAuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
